module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer-region",
    class: {
      focused: _vm.focused, dark: _vm.dark, plain: _vm.plain, inline: _vm.inline, 'read-only': _vm.readOnly
    }
  }, [_c('div', {
    ref: "editRegion",
    staticClass: "dotted-underline edit-region",
    attrs: {
      "contenteditable": !_vm.readOnly
    },
    on: {
      "focus": _vm.gotFocus,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancel($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return $event.target.blur()
      }],
      "blur": _vm.changed,
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v(_vm._s(_vm.value))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57a4b9d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/EditableText.vue
// module id = 2556
// module chunks = 1